import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

const CITIES = [
  'Genève',
  'Lausanne',
  'Neuchâtel',
  'Montreux',
  'Crans-Montana',
  'Verbier',
  'Villars'
];

export default function EstimationStep1({ formData, errors, updateFormData, onNext }) {
  return (
    <div data-testid="estimation-step-1">
      <h2 className="text-2xl font-semibold text-[#2B2B2B] mb-6">
        Parlez-nous de votre bien
      </h2>

      <div className="space-y-6">
        <div>
          <Label htmlFor="property_type">Type de bien *</Label>
          <Select 
            value={formData.property_type} 
            onValueChange={(value) => updateFormData('property_type', value)}
          >
            <SelectTrigger data-testid="estimation-property-type">
              <SelectValue placeholder="Sélectionnez" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="appartement">Appartement</SelectItem>
              <SelectItem value="maison">Maison</SelectItem>
            </SelectContent>
          </Select>
          {errors.property_type && <p className="text-sm text-red-500 mt-1">{errors.property_type}</p>}
        </div>

        <div>
          <Label htmlFor="city">Ville *</Label>
          <Select 
            value={formData.city} 
            onValueChange={(value) => updateFormData('city', value)}
          >
            <SelectTrigger data-testid="estimation-city">
              <SelectValue placeholder="Sélectionnez une ville" />
            </SelectTrigger>
            <SelectContent>
              {CITIES.map(city => (
                <SelectItem key={city} value={city}>{city}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          {errors.city && <p className="text-sm text-red-500 mt-1">{errors.city}</p>}
        </div>

        <div>
          <Label htmlFor="bedrooms">Nombre de chambres *</Label>
          <Input
            id="bedrooms"
            type="number"
            min="1"
            value={formData.bedrooms}
            onChange={(e) => updateFormData('bedrooms', e.target.value)}
            placeholder="Ex: 2"
            data-testid="estimation-bedrooms"
          />
          {errors.bedrooms && <p className="text-sm text-red-500 mt-1">{errors.bedrooms}</p>}
        </div>
      </div>

      <Button
        onClick={onNext}
        className="w-full mt-8 bg-[#8A9474] hover:bg-[#7A8464] text-white"
        data-testid="estimation-next-1"
      >
        Continuer <ArrowRight className="ml-2 h-4 w-4" />
      </Button>
    </div>
  );
}
